/**
 * Money formatting.
 *
 * Amounts cross the wire as decimal STRINGS, never floats - the server does
 * every calculation in integer paise (see pricing.service) precisely so a
 * rupee figure is never the result of binary floating point. Parsing one here
 * only to display it is safe; doing arithmetic on it is not, which is why the
 * only arithmetic in these screens is on quantities and the discount the user
 * types, and every total shown after billing comes from the server.
 */

const FORMAT = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** "4136" -> "₹4,136.00". Indian digit grouping, because the users read lakhs. */
export function rupees(amount: string | number | null | undefined): string {
  if (amount === null || amount === undefined || amount === "") return "—";
  const value = Number(amount);
  return Number.isFinite(value) ? `₹${FORMAT.format(value)}` : "—";
}

/** Plain grouped number, for a subtotal column that already says "₹" above it. */
export function amount(value: string | number): string {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? FORMAT.format(parsed) : "—";
}

/**
 * The brief's name for `rupees`, so "currency uses formatINR()" is literally
 * true in the code. Same function - there is one money formatter here, not
 * two, because two would eventually disagree about where the commas go.
 */
export const formatINR = rupees;
